<template>
	<tile-card :to="targetDestination">
		<div class="avatar-container float-right mt-3 mr-3">
			<user-avatar :user="user" />
		</div>

		<v-list-item :two-line="!!user.displayName">
			<v-list-item-content>
				<div class="user-type overline">
					{{ user.relationship || user.userType }}
				</div>
				<v-list-item-title v-if="user.displayName" class="name headline">
					{{ user.displayName }}
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

		<div class="details pb-4">
			<v-list-item v-if="user.address.address" dense>
				<v-list-item-icon>
					<v-icon>fas fa-map-marker-alt</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-subtitle class="address">
						{{ user.address.address }}
					</v-list-item-subtitle>
					<v-list-item-subtitle v-if="user.address.zipcode" class="zipcode">
						{{ user.address.zipcode }}
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-list-item v-if="user.phone" dense>
				<v-list-item-icon><v-icon>fas fa-phone</v-icon></v-list-item-icon>
				<v-list-item-subtitle class="phone">
					<a :href="`tel:${user.phone}`">{{ user.phone }}</a>
				</v-list-item-subtitle>
			</v-list-item>

			<v-list-item v-if="user.email" dense>
				<v-list-item-icon>
					<v-icon>far fa-envelope</v-icon>
				</v-list-item-icon>
				<v-list-item-subtitle class="email">
					<a :href="`mailto:${user.email}`">{{ user.email }}</a>
				</v-list-item-subtitle>
			</v-list-item>

			<v-list-item v-if="user.birthday" dense>
				<v-list-item-icon>
					<v-icon>fas fa-birthday-cake</v-icon>
				</v-list-item-icon>
				<v-list-item-subtitle class="birthday">
					{{ user.readableBirthday }}
				</v-list-item-subtitle>
			</v-list-item>
		</div>

		<template #actions>
			<v-spacer />
			<v-btn class="action-btn" :ripple="false" text>
				{{ actionText }}
				<v-icon class="ml-2" x-small>fa fa-arrow-right</v-icon>
			</v-btn>
		</template>
	</tile-card>
</template>

<style lang="scss" scoped>
.details {
	// List item titles are elided by default, but we want to show everything.
	.v-list-item__subtitle {
		white-space: normal;
	}

	// Just underline for links, no special color
	a {
		color: inherit;
	}
}
</style>

<script>
import _ from "lodash";

import TileCard from "../../shared/TileCard";

export default {
	components: { TileCard },

	props: {
		user: { type: Object, default: null },
	},

	computed: {
		userPage() {
			return {
				name: "Live User",
				params: { userId: this.user.guid },
			};
		},

		userEditPage() {
			return {
				name: "Live User Edit",
				params: { userId: this.user.guid },
			};
		},

		isUserPage() {
			return _.isMatch(this.$route, this.userPage);
		},

		targetDestination() {
			return this.isUserPage ? this.userEditPage : this.userPage;
		},

		actionText() {
			return this.isUserPage ? "Edit user" : "View user";
		},
	},
};
</script>
